import React, { useEffect, useState } from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './Career.module.scss'
import RankRow, { RankProps } from '../rank-row/RankRow'
import SectionHead from '../section-head/SectionHead'

interface Item extends RankProps {
  displayIndex: number
}

const ANIMATION_TICK = 500

function getNewDisplayIndex (items: Item[], item: Item) {
  if (item.highlighted && item.displayIndex > 0) {
    return item.displayIndex - 1
  }
  const highlightedIndex = items[3].displayIndex
  if (!item.highlighted && item.displayIndex === highlightedIndex - 1) {
    return item.displayIndex + 1
  }
  return item.displayIndex
}

const playerPoints = [
  '300 000',
  '221 564',
  '182 099',
  '174 274'
]

const Career: React.FC = () => {
  const t = useIntl()
  const [tick, setTick] = useState<number>(0)

  const [rowProperties, setRowProperties] = useState<Item[]>([
    {
      displayIndex: 0,
      rank: 50,
      name: 'SteelFort',
      points: '245 270'
    },
    {
      displayIndex: 1,
      rank: 51,
      name: 'MissRubis',
      points: '201 054'
    },
    {
      displayIndex: 2,
      rank: 52,
      name: 'RaptorTwo',
      points: '180 874'
    },
    {
      displayIndex: 3,
      rank: 53,
      name: 'Nagrarok',
      points: playerPoints[3],
      highlighted: true
    }
  ])

  useEffect(() => {
    const interval = setInterval(() => {
      setTick(tick + 1)

      if (tick <= 12) {
        if (tick % 4 === 0) {
          setRowProperties(items => items.map(item => {
            const newDisplayIndex = getNewDisplayIndex(rowProperties, item)
            return {
              ...item,
              rank: 50 + newDisplayIndex,
              displayIndex: newDisplayIndex,
              showCounter: tick <= 10 && item.highlighted,
              points: item.highlighted ? playerPoints[newDisplayIndex] : item.points,
              style: {
                opacity: 1,
                transform: item.highlighted ? 'scale(1.05)' : 'scale(1)'
              }
            }
          }))
        } else if (tick % 4 === 2) {
          setRowProperties(items => items.map(item => {
            return {
              ...item,
              showCounter: false
            }
          }))
        }
      } else if (tick === 14) {
        setRowProperties(items => items.map((item, index) => {
          return {
            ...item,
            style: {
              opacity: 0.01,
              transform: item.highlighted ? 'scale(1.05)' : 'scale(1)'
            }
          }
        }))
      } else if (tick === 16) {
        setRowProperties(items => items.map((item, index) => {
          return {
            ...item,
            rank: 50 + index,
            displayIndex: index,
            style: {
              opacity: 0.01,
              transition: 'none'
            },
            points: item.highlighted ? playerPoints[3] : item.points
          }
        }))
      } else if (tick === 17) {
        setRowProperties(items => items.map((item, index) => {
          return {
            ...item,
            style: { opacity: 1, transition: 'all 1s ease-out' },
            showCounter: false
          }
        }))
      } else if (tick === 18) {
        setTick(0)
      }
    }, ANIMATION_TICK)
    return () => clearInterval(interval)
  })

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <StaticImage
          className={styles.rightBackground}
          alt=''
          width={228}
          height={453}
          src='./assets/right_bg_prism.png'
          style={{ position: 'absolute' }}
        />
        <StaticImage
          className={styles.leftBackground}
          alt=''
          width={167}
          height={426}
          src='./assets/left_bg_prism.png'
          style={{ position: 'absolute' }}
        />

        <div className={styles.head}>
          <SectionHead
            title={t.formatMessage({ id: 'career.title' })}
            text={t.formatMessage({ id: 'career.subtitle1' })}
          />
        </div>

        <div className={styles.ranking}>
          {rowProperties.map(({ displayIndex, name, style, ...props }) => (
            <RankRow
              key={name}
              name={name}
              {...props}
              style={{
                top: displayIndex * 82,
                ...style
              }}
            />
          ))}
        </div>

      </div>
    </div>
  )
}

export default Career
